
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Quand utiliser un framework : Conseils pour prendre la bonne décision",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez facilement si un site web a été créé avec un CMS en suivant ces étapes simples. Apprenez à reconnaître les signes distinctifs d'un CMS.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Quand utiliser un framework : Conseils pour prendre la bonne décision",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez facilement si un site web a été créé avec un CMS en suivant ces étapes simples. Apprenez à reconnaître les signes distinctifs d'un CMS.",
        },
      ],
    };
  },
};
